<app-contract [latestUpdateDate]="false">
  <div class="mt-12 mb-6">
    <div class="container mx-auto flex flex-col gap-6 sm:px-0 px-4">
      <div [inlineSVG]="svgName" class="flex justify-center"></div>
    </div>
  </div>
</app-contract>
